<fa-icon class="drop-icon" icon="inbox"></fa-icon>
<div class="body1">
    Drag and Drop Widgets here
</div>
<div class="body2 text-secondary text-center">
    Under Add Widgets, choose which widgets you want to add<br />and drag and drop them into the dashboard.
</div>
